"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _propTypes = require("../prop-types");

var _screenReaderOnly = require("../screen-reader-only");

var _text = require("../text");

var _core = require("@emotion/core");

var AvatarTextBase = _text.Text.withComponent('span', {
  target: "e1b9w7yl0"
});

AvatarTextBase.displayName = 'AvatarTextBase';
AvatarTextBase.propTypes = _text.Text.propTypes;
AvatarTextBase.defaultProps = _text.Text.defaultProps;

var AvatarText = function AvatarText(_ref) {
  var children = _ref.children,
      fontSize = _ref.fontSize,
      lineHeight = _ref.lineHeight,
      hiddenText = _ref.hiddenText;
  return (0, _core.jsx)(_react.default.Fragment, null, !!hiddenText && (0, _core.jsx)(_screenReaderOnly.ScreenReaderOnly, null, hiddenText), (0, _core.jsx)(AvatarTextBase, {
    display: "inline",
    fontSize: fontSize,
    lineHeight: lineHeight
  }, children));
};

AvatarText.displayName = 'AvatarText';
var AvatarTextWithDocs = (0, _stencilReactDesc.describe)(AvatarText).description('Used to display additional information about the employee.');
AvatarTextWithDocs.propTypes = {
  children: _stencilReactDesc.PropTypes.node.description('Text to be displayed in the additional info.').isRequired,
  fontSize: (0, _propTypes.cssValue)().description("Sets the CSS 'font-size' property for the text element."),
  lineHeight: (0, _propTypes.cssValue)().description("Sets the CSS 'line-height' property for the text element."),
  hiddenText: _stencilReactDesc.PropTypes.string.description('Sets the hidden label for the text.')
};
var _default = AvatarTextWithDocs;
exports.default = _default;